import { render, staticRenderFns } from "./TravelData.vue?vue&type=template&id=7a5e0694&scoped=true&"
import script from "./TravelData.vue?vue&type=script&lang=js&"
export * from "./TravelData.vue?vue&type=script&lang=js&"
import style0 from "./TravelData.vue?vue&type=style&index=0&id=7a5e0694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5e0694",
  null
  
)

export default component.exports